module.exports = __webpack_public_path__ + "static/media/fondonotificacion.6774d060.png";